import {
  PRICING_MASTER_ENABLE_LOADING,
  PRICING_MASTER_DISABLE_LOADING,
  PRICING_MASTER_ENABLE_METADATA_LOADING,
  PRICING_MASTER_DISABLE_METADATA_LOADING,
  PRICING_MASTER_UPDATE_CHARGES,
  PRICING_MASTER_SET_SELECTED_CHARGE,
  PRICING_MASTER_UPDATE_TABLE_DATA,
  PRICING_MASTER_UPDATE_PAGINATION,
  APPROVAL_SET_MASTER_DATA,
  APPROVAL_SET_MASTER_DATA_LOADING,
  APPROVAL_PENDING_COUNT_REFRESH,
} from '../actions/constants';

const defaultState = {
  loading: false,
  metadataLoading: false,
  chargesData: [],
  selectedCharge: null,
  tableData: [],
  pagination: {
    currentPageNumber: 1,
    nextOrPrev: 'first',
    isNextPresent: false,
    lastIdNext: null,
    lastPrimarySortFieldNext: null,
    lastIdPrev: null,
    lastPrimarySortFieldValuePrev: null,
  },
  approval: {
    masterData: null,
    masterDataLoading: false,
    pendingCountRefreshTrigger: 0,
  },
};

export default function pricingMasterReducer(state = defaultState, action) {
  switch (action.type) {
    case PRICING_MASTER_ENABLE_LOADING:
      return { ...state, loading: true };
    case PRICING_MASTER_DISABLE_LOADING:
      return { ...state, loading: false };
    case PRICING_MASTER_ENABLE_METADATA_LOADING:
      return { ...state, metadataLoading: true };
    case PRICING_MASTER_DISABLE_METADATA_LOADING:
      return { ...state, metadataLoading: false };
    case PRICING_MASTER_UPDATE_CHARGES:
      return { ...state, chargesData: action.data };
    case PRICING_MASTER_SET_SELECTED_CHARGE:
      return { ...state, selectedCharge: action.data };
    case PRICING_MASTER_UPDATE_TABLE_DATA:
      return { ...state, tableData: action.data };
    case PRICING_MASTER_UPDATE_PAGINATION:
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.data,
        },
      };
    case APPROVAL_SET_MASTER_DATA:
      return {
        ...state,
        approval: { ...state.approval, masterData: action.data },
      };
    case APPROVAL_SET_MASTER_DATA_LOADING:
      return {
        ...state,
        approval: { ...state.approval, masterDataLoading: action.data },
      };
    case APPROVAL_PENDING_COUNT_REFRESH:
      return {
        ...state,
        approval: {
          ...state.approval,
          pendingCountRefreshTrigger:
            state.approval.pendingCountRefreshTrigger + 1,
        },
      };
    default:
      return state;
  }
}
